function createApiPath(path) {
  return `/marketing-car-summary${path}`;
}
export function createApi(httpClient) {
  function getSimilarBoughtCars(carleadHash) {
    return httpClient.get(createApiPath(`/similar-bought-car/${carleadHash}`)).then(r => {
      return r.data;
    });
  }
  return {
    getSimilarBoughtCars
  };
}